import { BreifInfluencerV2MainStatusEnum } from "@shared/lib/types/brief";

export function getStatusLabel(
  status: BreifInfluencerV2MainStatusEnum
): string {
  const statusLabelMap: Record<BreifInfluencerV2MainStatusEnum, string> = {
    [BreifInfluencerV2MainStatusEnum.Brief]: "In Brief",
    [BreifInfluencerV2MainStatusEnum.Campaign]: "In Execution",
    [BreifInfluencerV2MainStatusEnum.Cancelled]: "Cancelled",
    [BreifInfluencerV2MainStatusEnum.Withdrawn]: "Withdrawn",
    [BreifInfluencerV2MainStatusEnum.Deleted]: "Deleted",
    [BreifInfluencerV2MainStatusEnum.Completed]: "Completed",
  };
  return statusLabelMap[status] || "";
}

export function getStatusTagClassKey(
  status: BreifInfluencerV2MainStatusEnum
): string {
  const statusClassMap: Record<BreifInfluencerV2MainStatusEnum, string> = {
    [BreifInfluencerV2MainStatusEnum.Brief]: "statusBrief",
    [BreifInfluencerV2MainStatusEnum.Campaign]: "statusCampaign",
    [BreifInfluencerV2MainStatusEnum.Cancelled]: "statusCancelled",
    [BreifInfluencerV2MainStatusEnum.Withdrawn]: "statusWithdrawn",
    [BreifInfluencerV2MainStatusEnum.Deleted]: "statusDeleted",
    [BreifInfluencerV2MainStatusEnum.Completed]: "statusCompleted",
  };
  return statusClassMap[status] || "statusBrief";
}
